import {
  DefaultMatCalendarRangeStrategy,
  MAT_DATE_RANGE_SELECTION_STRATEGY,
  DateRange
} from '@angular/material/datepicker';
import { Injectable } from '@angular/core';

@Injectable()
export class CustomRangeStrategy<D>
  extends DefaultMatCalendarRangeStrategy<D> {

  override selectionFinished(
    date: D,
    currentRange: DateRange<D>
  ): DateRange<D> {

    const start = currentRange.start;
    const end = currentRange.end;

    if (start && !end) {
      return date < start
        ? new DateRange(date, start)
        : new DateRange(start, date);
    }

    return new DateRange(date, null);
  }

  override createPreview(
    activeDate: D | null,
    currentRange: DateRange<D>
  ): DateRange<D> {

    if (currentRange.start && activeDate) {
      return activeDate < currentRange.start
        ? new DateRange(activeDate, currentRange.start)
        : new DateRange(currentRange.start, activeDate);
    }

    return new DateRange<D>(null, null);
  }
}